export default __webpack_public_path__ + "static/assets/b994bb5bd035cae8b62468604f03436c.png";